import React from 'react';
import './PlaceholderPage.css';

const PoshmarkIntegrationPage = () => {
  return (
    <div className="placeholder-page">
      <h1 className="page-title">Poshmark Integration</h1>
      <p className="page-description">
        Poshmark marketplace integration settings will be added here.
      </p>
    </div>
  );
};

export default PoshmarkIntegrationPage;
